import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ConnectWallet } from '../wallet/ConnectWallet';
import { useAdminCheck } from '../../hooks/useAdminCheck';
import { APP_NAME } from '../../config/appConfig';

export const Header = () => {
  const { isPrivileged } = useAdminCheck();
  const nav = useNavigate();

  return (
    <header className="mobile-header">
      <div className="brand">
        <div className="brand-logo">Z</div>
        <div className="brand-name">{APP_NAME}</div>
      </div>
      <div className="flex" style={{ gap: 8, alignItems: 'center' }}>
        {isPrivileged && (
          <button className="admin-fab" onClick={() => nav('/admin')} title="Admin Panel">
            🔐 Admin
          </button>
        )}
        <ConnectWallet />
      </div>
    </header>
  );
};
